import { useSelector } from "react-redux";
import get from "lodash/get";
import {classNames} from "react-extras";
import { Field } from "redux-form";
import InfoTooltip from "../../../lib/info";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { validateCPM } from "./ad_settings_validation";
import { createNumberMask } from "redux-form-input-masks";
import ExternalLink from "../../../lib/external_link";
import { AD_SETTINGS_FORM_NAME } from "./constants";

const currencyMask = createNumberMask({
  prefix: "$ ",
  decimalPlaces: 2,
  locale: "en-US",

  // CPM is stored as Cents
  multiplier: 100,
});

const CPMRow = props => {
  const { name, defaultCPM, defaultCPMWithDiscount } = props;

  const cpmSelector = fieldName => {
    return state => get(state, ["form", AD_SETTINGS_FORM_NAME, "values", fieldName]);
  };
  const cpmFields = [
    { name: "PreRollCPM", default: defaultCPMWithDiscount, displayName: "Pre-Roll" },
    { name: "MidRollCPM", default: defaultCPM, displayName: "Mid-Roll" },
    { name: "PostRollCPM", default: defaultCPMWithDiscount, displayName: "Post-Roll" },
  ];

  const useCPM = fieldName => {
    return useSelector(cpmSelector(fieldName));
  };

  return (
    <div>
      <Row>
        {cpmFields.map(function useCPMField(field) {
          const fullFieldName = name + field.name;
          const currentCPM = useCPM(name + field.name);
          const [isInvalid, warningText] = validateCPM(currentCPM, field.default);

          return (
            <Col xs={12} md={4} key={field.name}>
              <div>
                <span className="redcircle-form-label">{field.displayName}</span>
              </div>
              <Field
                component="input"
                type="text"
                className="form-control margin-bottom--small"
                name={fullFieldName}
                {...currencyMask}
              />
              <div>
                <span className={classNames(!isInvalid && "text-warning", isInvalid && "text-danger", "small")}>{warningText}</span>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export const CPMForm = props => {
  const { defaultCPMByType } = props;

  const isHostReadEnabled = useSelector(state =>
    get(state, ["form", AD_SETTINGS_FORM_NAME, "values", "isHostReadEnabled"])
  );
  const isPreRecordedEnabled = useSelector(state =>
    get(state, ["form", AD_SETTINGS_FORM_NAME, "values", "isPreRecordedEnabled"])
  );

  return (
    <>
      <div>
        Select the types of ads you’d like to run and your rate for every 1000 downloads (CPM) for
        each ad spot.{" "}
        <ExternalLink href={"http://support.redcircle.com/en/articles/3591720-advertising"}>
          Learn More
        </ExternalLink>
      </div>
      <div className="flex-row-container align-center pointer margin-top--medium">
        <div className="margin-right--small">
          <Field
            id="hostRead"
            component="input"
            type="checkbox"
            name="isHostReadEnabled"
            checked={isHostReadEnabled}
          />
        </div>
        <label htmlFor="hostRead" className="no-margin h3 pointer ad-settings-modal-label">
          Host-Read
        </label>
        <InfoTooltip
          className={"info-tooltip--no-top-bump"}
          helpText={
            "Ad endorsements that are read and recorded by you. You approve ads and control where they’re inserted into your content."
          }
        />
      </div>
      {isHostReadEnabled && (
        <CPMRow
          name="hostRead"
          defaultCPM={defaultCPMByType.hostRead.default}
          defaultCPMWithDiscount={defaultCPMByType.hostRead.discount}
        />
      )}

      <div className="flex-row-container align-center pointer margin-top--large">
        <div>
          <div className="margin-right--small ">
            <Field
              id="preRecorded"
              component="input"
              type="checkbox"
              name="isPreRecordedEnabled"
              checked={isPreRecordedEnabled}
            />
          </div>
        </div>
        <label htmlFor="preRecorded" className="no-margin h3 pointer ad-settings-modal-label">
          Pre-Recorded
        </label>
        <InfoTooltip
          className={"info-tooltip--no-top-bump"}
          helpText={
            "Ads that are pre-recorded by the brand. You approve ads and control where they’re inserted into your content."
          }
        />
      </div>
      {isPreRecordedEnabled && (
        <CPMRow
          name="preRecorded"
          defaultCPM={defaultCPMByType.preRecorded.default}
          defaultCPMWithDiscount={defaultCPMByType.preRecorded.discount}
        />
      )}
    </>
  );
};
